/// <reference path="../_references.ts"/>

module App.Utils {
	export class ToastService {
		public static SUCCESS_SELECTOR = '#toast-service';
		public static ERROR_SELECTOR = '#toast-service-error';
		public static LOADING_SELECTOR = '#toast-service-loading';
		constructor() {

		}

		show(text: string, selector: string = ToastService.SUCCESS_SELECTOR, timeout: number = 20000): void {
			const snackbar = document.querySelector(selector);

			if (snackbar) {
				new MaterialSnackbar(snackbar).showSnackbar({
					message: text,
					timeout: timeout,
					actionHandler: function() {
						new MaterialSnackbar(snackbar).cleanup_()
					},
					actionText: 'x'
				});
			}
		}

		hide(selector: string = ToastService.SUCCESS_SELECTOR): void {
			const snackbar = document.querySelector(selector);

			if (snackbar) {
				new MaterialSnackbar(snackbar).cleanup_();
			}
		}

		showError(prefix: string, error?: {data?: {message?: string}}, defaultMessage?: string): void {
			this.show(prefix + (error && error.data && error.data.message || defaultMessage || 'Unknown Error'), ToastService.ERROR_SELECTOR);
		}

		showLoading(text: string): void {
			this.show(text, ToastService.LOADING_SELECTOR, 3600000000);
		}

		hideLoading(): void {
			this.hide(ToastService.LOADING_SELECTOR);
		}

		public static Factory() {
			let instance = () => {
				return new ToastService();
			};

			instance.$inject = [];

			return instance;
		}
	}

	export class DefaultToasts {
		private ToastService: ToastService = new ToastService();
		displayWarning(text: string) {
			this.ToastService.show(text);
		}
		displaySuccess(text: string) {
			this.ToastService.show(text);
		}
		display(text: string) {
			this.ToastService.show(text);
		}
		displayError(err: {data?: {message?: string}}, prefix: string, defaultMessage?: string) {
			this.ToastService.showError(prefix, err, defaultMessage);
		}
		displayLoading(text: string) {
			this.ToastService.showLoading(text);
		}
		hideLoading() {
			this.ToastService.hideLoading();
		}
		hide() {
			this.ToastService.hide();
		}

		public static Factory() {
			let instance = () => {
				return new DefaultToasts();
			};

			instance.$inject = [];

			return instance;
		}
	}
}